<template>
  <div class="home" :style="showFilter">
    <!-- <div class="shade"></div> -->
    <el-container class="left-part">
      <!-- 菜单 -->
      <el-aside width="auto">
        <homeMenu v-if="common.isRouterAlive" :menuData="menuData" />
      </el-aside>
      <el-container>
        <!-- 导航栏 -->
        <el-header>
          <homeNavbar />
        </el-header>
        <el-main>
        

          <transition name="el-fade-in-linear">
            <div class="main-box">
              <keep-alive>
                <router-view v-if="common.isRouterAlive && $route.meta && $route.meta.keepAlive" />
              </keep-alive>
              <router-view v-if="common.isRouterAlive && (!$route.meta || !$route.meta.keepAlive)" />
            </div>
          </transition>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
//菜单
import homeMenu from "./components/home-menu/homeMenu.vue";
import homeNavbar from "./components/home-navbar/homeNavbar";

export default {
  components: {
    homeMenu,
    homeNavbar,
  },
  data() {
    return {
      showFilter: {}, //灰色滤镜
      filterData: [],
      startTime: "", //2022-12-16 12:00:00
      endTime: "", //2022-12-30 12:00:00
      // isRouterAlive: true,
      menuData: [],
    };
  },
  created() {
    // 判断是否需要灰色滤镜
    // this.handleFilter();
    this.selectMenuByTeacherId();
    // console.log(this.user)
  },
  provide() {
    return {};
  },
  methods: {
    // 判断是否需要灰色滤镜
    handleFilter() {
      var currentTime = new Date();
      currentTime.getUTCDate();
      this.get(this.$url.globalColor)
        .then((res) => {
          // console.log(res);
          if (res.code !== 200) return;
          this.filterData = res.data;
          if (this.filterData.color == "gray") {
            this.startTime = new Date(Date.parse(this.filterData.startTime));
            this.endTime = new Date(Date.parse(this.filterData.endTime));
            if (currentTime > this.startTime && currentTime < this.endTime) {
              this.showFilter = { filter: "grayscale(100%)" };
            }
          }
        })
        .catch((err) => {
          // this.$message.error("获取滤镜失败，请联系管理员");
        });
    },
    selectMenuByTeacherId() {
      this.get(this.$url.selectMenuByTeacherId).then((res) => {
        // console.log("获取用户绑定菜单列表==>", res);
        if (res.code != 200) {
          return this.$message.error("获取菜单列表失败");
        }
        let menuList = res.data;
        // 遍历menuList数组，将子菜单添加到对应的父菜单的childMenu属性中
        menuList.forEach((menu) => {
          const parentId = menu.parentId;
          if (parentId !== 0) {
            const parentMenu = menuList.find((item) => item.id === parentId);
            if (parentMenu) {
              if (!parentMenu.childMenu) {
                parentMenu.childMenu = [];
                parentMenu.children = [];
              }
              if (menu.menuType != "F") {
                parentMenu.childMenu.push(menu);
              }
              parentMenu.children.push(menu);
            }
          }
        });

        // 使用 filter 方法过滤掉不需要的对象
        this.menuData = menuList.filter((menu) => menu.parentId === 0);
        // console.log("menuData==>", this.menuData);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./home.scss";
</style>
